import script from "./discountList.vue?vue&type=script&setup=true&lang=js"
export * from "./discountList.vue?vue&type=script&setup=true&lang=js"

import "./discountList.vue?vue&type=style&index=0&id=509c6d58&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-509c6d58"]])

export default __exports__